import { render, staticRenderFns } from "./digitalJuegos.vue?vue&type=template&id=cf2e3f4a"
import script from "./digitalJuegos.vue?vue&type=script&lang=js"
export * from "./digitalJuegos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports